import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data
    return !(
      data.tasks_boards.length === 0 && data.vaxiom_task_baskets.length > 0
    )
      ? [true]
      : []
  }, [data])
}
